import getClassroomsAvailableForThatDay from '@teetsh/app/src/components/EDT/getClassroomsAvailableForThatDay';
import useClassrooms from './useClassrooms';

export default function useClassroomsForThatDay(day: number) {
  const classrooms = useClassrooms();
  return getClassroomsAvailableForThatDay(classrooms, day) || [];
}
